module.exports = __webpack_public_path__ + "img/barva-zakladni_81_viridian-zelena.527f112b.png";